export const COLUMNS_HIDDEN_FROM_COLUMN_PANEL = ["__check__", "actions", "driveActions"];
export const COLUMNS_NOT_HIDEABLE = ["id", "name"];
